import { Injectable } from '@angular/core';
import {
  CloseMfaData,
  MfaActionsService,
  MfaContextType,
  MfaService,
  VerifyMfaCodeData,
} from 'common';
import { MfaLoginService } from './services/mfa-login.service';
import { MfaResetPasswordService } from './services/mfa-reset-password.service';
import { MfaChangePasswordService } from './services/mfa-change-password.service';
import { Subscription } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable()
export class MfaFacade {
  constructor(
    private mfaActions: MfaActionsService,
    private mfaService: MfaService,
    private mfaLoginService: MfaLoginService,
    private mfaResetPasswordService: MfaResetPasswordService,
    private mfaChangePasswordService: MfaChangePasswordService,
  ) { }

  initActions(): void {
    this.mfaActions.verifyMfaCode$
      .pipe(untilDestroyed(this))
      .subscribe((data: VerifyMfaCodeData) => {
        this.verifyMfaCode(data);
      });

    this.mfaActions.close$
      .pipe(untilDestroyed(this))
      .subscribe((data: CloseMfaData) => {
        this.close(data);
      });
  }

  private verifyMfaCode(data: VerifyMfaCodeData): void | Subscription {
    switch (data.mfaData.contextType) {
      case MfaContextType.Login:
        return this.mfaLoginService.verify(data);
      case MfaContextType.ResetPassword:
        return this.mfaResetPasswordService.verify(data);
      case MfaContextType.ChangePassword:
        return this.mfaChangePasswordService.verify(data);
      default:
        this.mfaService.handleMfaError('Invalid mfaContextType to verify');
        break;
    }
  }

  private close(data: CloseMfaData): void {
    switch (data.contextType) {
      case MfaContextType.Login:
      case MfaContextType.ResetPassword:
      default:
        this.mfaService.handleDefaultCloseAction();
        break;
    }
  }
}
